import api from "./core";

const basePath = "api/{{serverSegment}}/Users";

export default {
  get(id) {
    return api.get(`${basePath}/${id}`);
  },
  update(id, data) {
    return api.patch(`${basePath}/${id}`, data);
  },
  delete(id) {
    return api.delete(`${basePath}/${id}`);
  },
  query(filter) {
    return api.post(`${basePath}`, filter);
  },
  getFilteredUsers() {
    return api.post(`${basePath}/GetFilteredUsers`);
  },
  create(data) {
    return api.put(`${basePath}`, data);
  },
  updateCurrentUserProfile(data) {
    return api.patch(`${basePath}/EditProfile`, data);
  },
  changeCurrentUserPassword(data) {
    return api.patch(`${basePath}/ChangePassword`, data);
  },
  updateCurrentUserSignature(data) {
    return api.patch(`${basePath}/SetSignature`, data);
  },
  changeUserPassword(id, data) {
    return api.patch(`${basePath}/SetPassword/${id}`, data);
  },
  agreeToEULA(id) {
    return api.post(`${basePath}/AgreeToEULA/${id}`);
  }
};
